module.exports = __webpack_public_path__ + "img/info1.3c06b20f.png";